import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import PanelAcademicoView from './PanelAcademicoView';
import * as ROUTES from '../../../router/Routes';

const PanelAcademicoModule = () => {
  return (
    <ContainerTemplate active={ROUTES.academico} routes={[]}>
      <PanelAcademicoView />
    </ContainerTemplate>
  );
};

export default PanelAcademicoModule;
